import { Group, SimpleGrid, Text } from "@mantine/core";
import {
  IconCheck,
  IconClockHour4,
  IconMap2,
  IconUsers,
  IconWorld,
  IconX,
} from "@tabler/icons-react";
import classes from "./AllPolicyStats.module.css";

const TRIP_CARDS = [
  { key: "total", label: "Total Trips", color: "#F97316", bg: "#FFF4E8", Icon: IconWorld },
  { key: "active", label: "Active", color: "#16A34A", bg: "#ECFDF3", Icon: IconCheck },
  { key: "inactive", label: "Inactive", color: "#2563EB", bg: "#EFF6FF", Icon: IconMap2 },
  { key: "expired", label: "Expired", color: "#DC2626", bg: "#FEF2F2", Icon: IconClockHour4 },
  { key: "picked", label: "Picked", color: "#059669", bg: "#ECFDF5", Icon: IconCheck },
  { key: "unpicked", label: "Unpicked", color: "#D97706", bg: "#FFFBEB", Icon: IconX },
];

const TRAVELLER_CARDS = [
  { key: "total", label: "Total Travellers", color: "#F97316", bg: "#FFF4E8", Icon: IconUsers },
  { key: "successful", label: "Successful", color: "#16A34A", bg: "#ECFDF3", Icon: IconCheck },
  { key: "failed", label: "Failed", color: "#DC2626", bg: "#FEF2F2", Icon: IconX },
  { key: "pending", label: "Pending", color: "#2563EB", bg: "#EFF6FF", Icon: IconClockHour4 },
];

const AllPolicyStats = ({ stats, loading, variant = "trips" }) => {
  const cards = variant === "travellers" ? TRAVELLER_CARDS : TRIP_CARDS;

  return (
    <SimpleGrid cols={{ base: 1, xs: 2, sm: 3, lg: 6 }} spacing="md" mb="sm">
      {cards.map(({ key, label, color, bg, Icon }) => (
        <div key={key} className={classes.card} style={{ background: bg }}>
          <Group justify="space-between" align="flex-start" wrap="nowrap">
            <div>
              <Text className={classes.value} style={{ color }}>
                {loading ? "—" : (stats?.[key] ?? 0).toLocaleString("en-IN")}
              </Text>
              <Text className={classes.label} style={{ color }}>
                {label}
              </Text>
            </div>
            <div className={classes.iconWrap} style={{ color }}>
              <Icon size={22} stroke={1.6} />
            </div>
          </Group>
        </div>
      ))}
    </SimpleGrid>
  );
};

export default AllPolicyStats;
